import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { FaHeart, FaFilm, FaTicketAlt } from "react-icons/fa";

export default function Tickets() {
  const ref = useScrollAnimation();

  return (
    <section
      id="tickets"
      style={{
        background: "#0a0a0f",
        padding: "clamp(64px,10vw,120px) clamp(20px,5vw,80px)",
      }}
    >
      <div ref={ref} style={{ maxWidth: "1100px", margin: "0 auto" }}>
        {/* Header */}
        <div style={{ marginBottom: "56px", textAlign: "center" }}>
          <div
            className="section-label animate-on-scroll"
            style={{ justifyContent: "center", marginBottom: "16px" }}
          >
            Join the Fear
          </div>
          <h2
            className="display-heading animate-on-scroll"
            style={{
              fontSize: "clamp(2.5rem,6vw,4.5rem)",
              color: "#e8e8e8",
              transitionDelay: "100ms",
            }}
          >
            Get Your <span style={{ color: "#cc0000" }}>Tickets</span>
          </h2>
          <p
            className="animate-on-scroll"
            style={{
              color: "rgba(232,232,232,0.6)",
              fontSize: "0.95rem",
              marginTop: "16px",
              transitionDelay: "150ms",
            }}
          >
            October 3, 2026 · Kan-Kan Cinema &amp; Brasserie
          </p>
        </div>

        {/* Venue + CTA */}
        <div
          className="animate-on-scroll"
          style={{
            maxWidth: "720px",
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "40px",
            textAlign: "center",
          }}
        >
          {/* Venue description */}
          <div
            style={{
              padding: "40px 32px",
              borderRadius: "16px",
              background: "rgba(255,255,255,0.03)",
              border: "1px solid rgba(255,255,255,0.07)",
              display: "flex",
              flexDirection: "column",
              gap: "24px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                color: "#cc0000",
              }}
            >
              <FaFilm />
              <span
                style={{
                  fontFamily: '"Bebas Neue", cursive',
                  fontSize: "0.75rem",
                  letterSpacing: "0.25em",
                  textTransform: "uppercase",
                }}
              >
                Our Venue
              </span>
            </div>

            <h3
              className="display-heading"
              style={{ fontSize: "clamp(1.5rem,4vw,2.2rem)", color: "#e8e8e8" }}
            >
              Kan-Kan Cinema &amp; Brasserie
            </h3>

            <p
              style={{
                fontSize: "0.95rem",
                color: "rgba(232,232,232,0.7)",
                lineHeight: 1.8,
                maxWidth: "580px",
                margin: "0 auto",
              }}
            >
              Indianapolis' only locally owned arthouse cinema, Kan-Kan is a
              one-of-a-kind venue that pairs curated independent and
              experimental film programming with a full bar and restaurant.
              Nestled in the Windsor Park neighborhood at 1258 Windsor St., it's
              a community hub for film lovers who want more than a multiplex —
              featuring themed series, filmmaker Q&amp;As, and a genuinely
              eclectic atmosphere that makes every screening an event.
            </p>

            <p
              style={{
                fontSize: "0.85rem",
                color: "rgba(232,232,232,0.45)",
                letterSpacing: "0.04em",
              }}
            >
              1258 Windsor St. · Indianapolis, IN · Windsor Park
            </p>
          </div>

          {/* CTA Button */}
          <a
            href="https://kankanindy.com/events/midwestfearfest/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
            style={{
              fontSize: "1.1rem",
              padding: "18px 52px",
              textDecoration: "none",
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <FaTicketAlt style={{ fontSize: "0.95em" }} />
            Get Tickets
          </a>
        </div>

        {/* Fine print */}
        <p
          className="animate-on-scroll"
          style={{
            textAlign: "center",
            marginTop: "32px",
            fontSize: "0.78rem",
            color: "rgba(136,136,153,0.65)",
            letterSpacing: "0.04em",
          }}
        >
          All ticket sales are final. Tickets also available at the door
          (subject to availability). Ages 13+.
        </p>

        {/* Donation */}
        <div
          className="animate-on-scroll"
          style={{
            marginTop: "64px",
            padding: "40px 32px",
            borderRadius: "16px",
            background: "rgba(204,0,0,0.06)",
            border: "1px solid rgba(204,0,0,0.18)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "24px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              color: "#cc0000",
            }}
          >
            <FaHeart />
            <span
              style={{
                fontFamily: '"Bebas Neue", cursive',
                fontSize: "0.75rem",
                letterSpacing: "0.25em",
                textTransform: "uppercase",
              }}
            >
              Support the Festival
            </span>
          </div>
          <h3
            className="display-heading"
            style={{ fontSize: "clamp(1.5rem,4vw,2.5rem)", color: "#e8e8e8" }}
          >
            Help Keep Independent Cinema Alive
          </h3>
          <p
            style={{
              fontSize: "0.9rem",
              color: "rgba(232,232,232,0.65)",
              maxWidth: "520px",
              lineHeight: 1.7,
            }}
          >
            Midwest Fear Fest is an independent, community-driven event. Your
            donation goes directly toward supporting filmmakers, improving the
            festival experience, and keeping tickets accessible for everyone.
          </p>

          <div
            style={{
              display: "flex",
              gap: "40px",
              alignItems: "center",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            <a
              href="https://www.paypal.com/donate/?hosted_button_id=L4H2TKJJYAHXY"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
              style={{ fontSize: "1rem", padding: "14px 36px" }}
            >
              <FaHeart style={{ fontSize: "0.85em" }} />
              Donate via PayPal
            </a>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <img
                src="https://c3store.nyc3.digitaloceanspaces.com/mwff/paypalQR.png"
                alt="Scan to donate via PayPal"
                style={{
                  width: "120px",
                  height: "120px",
                  borderRadius: "8px",
                  border: "1px solid rgba(255,255,255,0.1)",
                }}
              />
              <span
                style={{
                  fontSize: "0.65rem",
                  letterSpacing: "0.15em",
                  color: "rgba(136,136,153,0.6)",
                  textTransform: "uppercase",
                  fontFamily: '"Bebas Neue", cursive',
                }}
              >
                Scan to Donate
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
